export enum ClassCommissionMode{
  NoCommission="No Commission",
  RevenueShare="Revenue Share",
  FlatFees="FlatFees",
}

export enum ClassBehaviour{
  Session_Pack = "Session Pack",
  Membership_Session_Pack = "Membership + Session Pack",
  Anyone_Free = "Anyone (Free)",
  Members_Only_Session = "Members Only Session",
}

export enum ClassAppointmentCommissionMode
{
    NoCommission = 0,
    RevenueShare = 1,
    FlatFees = 2,
}

export enum AutoBumpWaitlist {
  Always = 1,
  OnlyInEarlyCancelWindow = 2,
  Never = 3,
}
